jQuery(document).ready(function ($) {
  // current url
  var currentURL = window.location.href;

  // window size
  var width = $(window).width();
  var height = $(window).height();

  // image alt
  $('img').each(function () {
    var img = $(this);
    var src = $(this).attr('src');
    var alt = $(this).attr('alt');
    var filename = src.split('/').reverse()[0].replace(/\.[^/.]+$/, '');
    if (img.parent('a').length !== 0) {
      console.log('parent is a link');
      if (alt === '' || alt === undefined) {
        img.attr('alt', 'image ' + filename);
      }
    } else {
      if (alt === '' || alt === undefined) {
        img.attr('alt', '');
      }
    }
  });

  // breadcrumbs
  $('ul.breadcrumb').prepend('<li><a href="/">Home</a></li>');

  // Image Captions
  $('.DnnModule-DNN_HTML img').each(function () {
    var img = $(this).css('margin', '');
    var width = $(this).css('width');
    var outerWidth = $(this).outerWidth();
    var imageCaption = $(this).attr('longdesc');
    var figure;
    if ($(img, 'figure').length === 1) {
      if (typeof imageCaption !== typeof undefined && imageCaption !== false) {
        if (img.hasClass('floatleft') || img.hasClass('float-left')) {
          img.css('float', '').css('height', 'auto');
          figure = $('<figure class="floatleft"></figure>').css('max-width', '100%');
          img.removeClass();
          img.wrap(figure);
          img.parent('figure').append('<figcaption style="max-width:' + width + '">' + imageCaption + '</figcaption>');
          img.attr('src', $(this).attr('src') + '?' + Math.random());
        } else if (img.hasClass('floatright') || img.hasClass('float-right')) {
          img.css('float', '').css('height', 'auto');
          figure = $('<figure class="floatright"></figure>').css('max-width', '100%');
          img.removeClass();
          img.wrap(figure);
          img.parent('figure').append('<figcaption style="max-width:' + width + '">' + imageCaption + '</figcaption>');
          img.attr('src', $(this).attr('src') + '?' + Math.random());
        } else if (img.hasClass('floatcenter') || img.hasClass('float-center')) {
          img.css('float', '').css('height', 'auto');
          figure = $('<figure class="floatcenter"></figure>').css('max-width', '100%');
          img.removeClass();
          img.wrap(figure);
          img.parent('figure').append('<figcaption style="max-width:' + width + '">' + imageCaption + '</figcaption>');
          img.attr('src', $(this).attr('src') + '?' + Math.random());
        }
      }
    }
  });
  // detect floats
  $('.DnnModule-DNN_HTML img').each(function () {
    if ($(this).css('float') == 'left') {
      $(this).addClass('float-left');
    }
    if ($(this).css('float') == 'right') {
      $(this).addClass('float-right');
    }
    // if ($(this).css('float') == 'absolute') {

    // }
  });
  // remove dnn checkbox styling
  (function () {
    $(document).ready(function () {
      $.fn.dnnCheckbox = function (options) { };
    });
  }());

  function RemoveDnnCheckboxFormat() {
    $('.dnnCheckbox').remove();
    $(':checkbox').removeAttr('style');
  }

  // product filter
  $(window).click(function () {
    if ($('.product-categories').hasClass('active')) {
      $('.product-categories').removeClass('active');
    }
  });
  $('.product-categories-link').on('click', function (e) {
    e.stopPropagation();
    if ($('.product-categories').hasClass('active')) {
      $('.product-categories').removeClass('active');
    } else {
      $('.product-categories').addClass('active');
    }
  });

  // filter products on filter click
  $('.product-categories-list a').on('click', function () {
    var catFilterAttr = $(this).attr('data-category');
    // console.log(catFilterAttr);
    $('.product-categories-link > span').text(catFilterAttr);
    $('article.product').each(function () {
      console.log($('.product-category > span', this).text());
      if (catFilterAttr === $('.product-category > span', this).text()) {
        $(this).show();
      } else if (catFilterAttr === 'All') {
        $('article.product').show();
      } else {
        $(this).hide();
      }
    });
  });

  // back to products link
  function backToProducts() {
    var productReferrer = window.location.href;
    var productReferrerSegments = productReferrer.split('/').length - 1 - (productReferrer.indexOf('://') == -1 ? 0 : 2);
    if (productReferrer.toLowerCase().indexOf('products-services') > 0 && productReferrerSegments > 1) {
      var productBackLink = productReferrer.substring(0, productReferrer.lastIndexOf('/'));
      $('.products-back').attr('href', productBackLink);
    }
  }
  backToProducts();

  // input masks
  $(':input').inputmask();

  // hide product content
  var productSegment = currentURL.substr(currentURL.lastIndexOf('/') + 1);
  var productSegmentLength = currentURL.split("/").length - 1 - (currentURL.indexOf("http://") == -1 ? 0 : 2);
  // console.log(productSegmentLength);
  if ((width >= 1024)) {
    if (productSegment === 'crop-protection') {
      $('.catalog-content').show();
      if (productSegmentLength > 4) {
        if ($('.product-specs + .accordion-content > dl').html().trim()) {
          $('.product-specs').show();
        }
        if (!$('.product-downloads + .accordion-content').is(':empty')) {
          $('.product-downloads').show();
        }
      }
    }
  }

  // find a person categories
  $('.find-person-search .product select option').each(function () {
    $(this).attr('hidden', true).attr('disabled', true);
  });
  $('.find-person-search .category select').on('change', function () {
    $('.product select option').removeAttr('selected');
    var cat = $(this).find(':selected').attr('data-cat');
    if (cat === 'brokerage' || cat === 'electronic payments') {
      $('.product select option[data-cat="products"]').remove();
      $('.product select').append('<option value="" selected="selected" data-cat="products">No products</option>');
      $('.product select').attr('disabled', true).attr('class', 'aspNetDisabled');
    } else if (cat === 'categories') {
      $('.product select option[data-cat="products"]').remove();
      $('.product select').append('<option value="" selected="selected" data-cat="products"></option>');
      $('.product select').attr('disabled', true).attr('class', 'aspNetDisabled');
    } else {
      $('.product select option[data-cat="products"]').remove();
      $('.product select').attr('disabled', false).attr('class', '');
      $('.product select option').each(function () {
        if ($(this).attr('data-cat') !== cat) {
          $(this).attr('hidden', true).attr('disabled', true);
        } else {
          $(this).attr('hidden', false).attr('disabled', false);
        }
      });
      $('.product select option[data-cat="' + cat + '"]:first').attr('selected', 'selected');
    }
  });

  // find a person on page load after search
  var selectedCat = $('.find-person-search .category select').find(':selected').attr('data-cat');
  if (selectedCat !== 'categories') {
    if (selectedCat === 'brokerage' || selectedCat === 'electronic payments') {
      $('.product select option[data-cat="products"]').remove();
      $('.product select').append('<option value="" selected="selected" data-cat="products">No products</option>');
      $('.product select').attr('disabled', true).attr('class', 'aspNetDisabled');
    } else if (selectedCat === 'categories') {
      $('.product select option[data-cat="products"]').remove();
      $('.product select').append('<option value="" selected="selected" data-cat="products"></option>');
      $('.product select').attr('disabled', true).attr('class', 'aspNetDisabled');
    } else {
      $('.product select option[data-cat="products"]').remove();
      $('.product select').attr('disabled', false).attr('class', '');
      $('.product select option').each(function () {
        if ($(this).attr('data-cat') !== selectedCat) {
          $(this).attr('hidden', true).attr('disabled', true);
        } else {
          $(this).attr('hidden', false).attr('disabled', false);
        }
      });
      $('.product select option[data-cat="' + selectedCat + '"]:first').attr('selected', 'selected');
    }
  }

  // find a person categories load filtering
  var personURL = currentURL.split('/');
  var personPageFilter = personURL[4];
  if (personPageFilter === 'c') {
    var selectedCategory = personURL[5];
    if (selectedCategory === 'brokerage' || selectedCategory === 'electronic payments') {
      $('.product select option[data-cat="products"]').remove();
      $('.product select').append('<option value="" selected="selected" data-cat="products">No products</option>');
      $('.product select').attr('disabled', true).attr('class', 'aspNetDisabled');
    } else if (selectedCategory === 'categories') {
      $('.product select option[data-cat="products"]').remove();
      $('.product select').append('<option value="" selected="selected" data-cat="products"></option>');
      $('.product select').attr('disabled', true).attr('class', 'aspNetDisabled');
    } else {
      $('.product select option[data-cat="products"]').remove();
      $('.product select').attr('disabled', false).attr('class', '');
      $('.product select option').each(function () {
        if ($(this).attr('data-cat') !== selectedCategory) {
          $(this).attr('hidden', true).attr('disabled', true);
        } else {
          $(this).attr('hidden', false).attr('disabled', false);
        }
      });
      $('.product select option[data-cat="' + selectedCategory + '"]:first').attr('selected', 'selected');
    }
  }

  // form builder labels
  $('.form-container span.label').each(function () {
    var formLabel = $(this);
    var formLabelClasses = $(this).attr('class');
    var formInputID = $(this).next('input[type="text"], select, textarea').attr('id');
    console.log(formInputID);
    formLabel.replaceWith(function () {
      return $('<label/>', {
        class: formLabelClasses,
        for: formInputID,
        html: this.innerHTML
      });
    });
  });
});